import { render, staticRenderFns } from "./createNewStory.vue?vue&type=template&id=27bf8489&class=px-0%20mx-0%20pt-0&"
import script from "./createNewStory.vue?vue&type=script&lang=js&"
export * from "./createNewStory.vue?vue&type=script&lang=js&"
import style0 from "./createNewStory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports